module.exports = __webpack_public_path__ + "static/media/immidream.1fc3b31a.jpeg";